import _ from "underscore";
import React from "react";
import { store as AlertStore, actions } from "../../utils/alert-store";
import ToastAlertClass from "../elements/toast-alert";

export default class extends React.Component {
  static displayName = "AlertController";
  state = { alerts: AlertStore.getAll() };

  componentDidMount() {
    return AlertStore.onChange(this.onChange);
  }

  componentWillUnmount() {
    return AlertStore.clearOnChange(this.onChange);
  }

  onChange = () => this.setState({ alerts: AlertStore.getAll() });

  render() {
    if (this.state.alerts.length) {
      return (
        <div className="et--alert-controller" style={this.props.style}>
          {this.state.alerts.map(({ config, key }) => (
            <div key={key}>
              <ToastAlertClass timeout={config.timeout} onClose={() => actions.removeToast(key)} type={config.type}>
                {config.message}
              </ToastAlertClass>
            </div>
          ))}
        </div>
      );
    } else {
      return null;
    }
  }
}
